function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h12v11.5H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 4V0h4v4h3L6 9 1 4h3z",
  fill: "#6F8190"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 11.5h12",
  stroke: "#6F8190",
  strokeWidth: 2
});

var SvgIconDownloadArrow = function SvgIconDownloadArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 13",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMS41IiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgNEw0IDBMOCAwVjRIMTFMNiA5TDEgNEg0WiIgZmlsbD0iIzZGODE5MCIvPgogICAgPHBhdGggZD0iTTAgMTEuNUgxMiIgc3Ryb2tlPSIjNkY4MTkwIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgIconDownloadArrow as ReactComponent };